module.exports = __webpack_public_path__ + "img/vertical_7_7_7005.bfe4eb58.png";